// context/AppContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { checkCode, get_cfg } from "./api/apis";
import { setSidGetter } from "./api/srs";


const AppContext = createContext();
export const useApp = () => useContext(AppContext);

export const AppProvider = ({ children, restaurant }) => {
    const [cfg, setCfgState] = useState(null);
    const [auth, setAuthState] = useState(null);
    const [loading, setLoading] = useState(true);
    const [menu, setMenuState] = useState([])

    const checkRestaurant = () => {
        if (cfg && restaurant && cfg.uid !== restaurant) {
            setCfg(null)
        }
    };

    useEffect(() => {
        checkRestaurant();
    }, [cfg, restaurant]);


    useEffect(() => {

    
      init();
    }, [restaurant]);

    const getMenu = menu;
    const setMenu = (input) => {
      setMenuState(input)
    }

    const init = async () => {
      // 1) Load whatever was in localStorage
      const raw = localStorage.getItem("cfg");
      let storedCfg;
      try {
        storedCfg = raw && raw !== "undefined" ? JSON.parse(raw) : null;
      } catch {
        localStorage.removeItem("cfg");
        storedCfg = null;
      }
  
      // 2) Remember any table the user already set
      const previousTable = storedCfg?.bord || "";
  
      // 3) Fetch fresh config from server
      const fresh = await get_cfg(restaurant);
  
      // 4) If we had a table, re-attach it to the new config
      if (previousTable && storedCfg?.uid === fresh.uid) {
        fresh.bord = previousTable;
      }
  
      // 5) Save it to state & localStorage
      setCfgState(fresh);
      localStorage.setItem("cfg", JSON.stringify(fresh));
  
      // …then handle sid, auth, loading as before…
      if (fresh.sid) setSidGetter(() => fresh.sid);
      // …your auth logic …
      setLoading(false);
    };
    
  
    const getAuth = async () => {
      if (auth?.phone && auth?.code) {
        const response = await checkCode(auth?.phone, auth?.code);
        if (response.ok) return auth;
      }
      setAuth(null);
      return null;
    };
  
    const getCfg = async () => {
      if (cfg) return cfg;
      const res = await get_cfg(restaurant);
      setCfg(res);
      return res;
    };

    useEffect(() => {
        if (cfg?.sid) {
          setSidGetter(() => cfg.sid); // ✅ This will be used by srs.sio_req()
        }
      }, [cfg]);
  
    const setCfg = (val) => {
      setCfgState(val);
      if(val == null)localStorage.removeItem("cfg");
      else{
          localStorage.setItem("cfg", JSON.stringify(val));
      }

    };
  
    const setAuth = (val) => {
      setAuthState(val);
      localStorage.setItem("auth", JSON.stringify(val));
    };

    const table = cfg?.bord;

    const setTable = (tableValue) => {
      const updatedCfg = { ...cfg, bord: tableValue };
      setCfg(updatedCfg); // already saves to localStorage
    };

    
  
    // sid getter (sync-style usage)
    const sid = cfg?.sid;
  
    if (loading) return null; // or return a <Loader />
  
    return (
      <AppContext.Provider
        value={{
          cfg,
          sid,
          setCfg,
          getCfg,
          table,
          setTable,
          auth,
          setAuth,
          getAuth,
          init,
          getMenu,
          setMenu
        }}
      >
        {children}
      </AppContext.Provider>
    );
  };
  
